export default __webpack_public_path__ + "static/perfect-email-v-34875ef863801900af3d421bac437092.webp";